var map = {
	"./Weflix-Escrita-Branco.svg": 2759,
	"./Weflix-Icone-Branco.svg": 1841,
	"./icon-assinatura.svg": 7516,
	"./icon-copy.svg": 2799,
	"./icon-time.svg": 8038,
	"./icon-video.svg": 9447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8387;